import BaseUIElement from "../BaseUIElement"
import { Utils } from "../../Utils"
/**
 * @deprecated
 */
export class FixedUiElement extends BaseUIElement {
    public readonly content: string

    constructor(html: string) {
        super()
        this.content = html ?? ""
    }
    protected InnerConstructElement(): HTMLElement {
        const e = document.createElement("span")
        e.innerHTML = Utils.purify(this.content)
        return e
    }
}
